export const categories = [
  { slug: 'korean', name: '韩漫', description: '韩国漫画精选合集，画风精美剧情精彩', icon: 'ri-flag-line' },
  { slug: 'japanese', name: '日漫', description: '日本漫画经典佳作，题材丰富多样', icon: 'ri-earth-line' },
  { slug: 'completed', name: '已完结', description: '完结漫画一次看个够', icon: 'ri-check-double-line' },
  { slug: 'ongoing', name: '连载中', description: '每周更新停不下来', icon: 'ri-loader-4-line' },
  { slug: 'romance', name: '恋爱', description: '甜蜜浪漫爱情故事', icon: 'ri-heart-line' },
  { slug: 'fantasy', name: '奇幻', description: '奇幻冒险异世界', icon: 'ri-magic-line' },
  { slug: 'action', name: '动作', description: '热血战斗激情澎湃', icon: 'ri-fire-line' },
  { slug: 'drama', name: '剧情', description: '深度剧情引人入胜', icon: 'ri-book-open-line' },
];

export const allCategoriesMap: Record<string, string> = {
  korean: '韩漫',
  japanese: '日漫',
  completed: '已完结',
  ongoing: '连载中',
  romance: '恋爱',
  fantasy: '奇幻',
  action: '动作',
  drama: '剧情',
};